module.exports = __webpack_public_path__ + "assets/img/txt-message-02.f41589dd.png";